'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp2;

var _reactMaskedinput = require('react-maskedinput');

var _reactMaskedinput2 = _interopRequireDefault(_reactMaskedinput);

var _reactRouter = require('react-router');

var _reactBootstrap = require('react-bootstrap');

var _components2 = require('components');

require('./RegistrationFormView.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    RegistrationFormView: {
        displayName: 'RegistrationFormView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Registration/RegistrationForm/default/RegistrationFormView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}
// import PhoneInput from 'react-telephone-input';


var RegistrationFormView = _wrapComponent('RegistrationFormView')((_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(RegistrationFormView, _Component);

    function RegistrationFormView() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, RegistrationFormView);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RegistrationFormView.__proto__ || (0, _getPrototypeOf2.default)(RegistrationFormView)).call.apply(_ref, [this].concat(args))), _this), _this.onClickAuth = function (event) {
            event.preventDefault();
            if (_this.props.onClickAuth) {
                _this.props.onClickAuth(event);
            }
        }, _this.showError = function () {
            var _this$props = _this.props,
                lang = _this$props.lang,
                errorsList = _this$props.errorsList;


            if (errorsList) {
                if (_this.props.errorCode === null || _this.props.errorCode === undefined) {
                    return _react3.default.createElement(
                        _reactBootstrap.Alert,
                        { bsStyle: 'danger', className: 'inner-right-xs' },
                        lang['store.common.server_is_unavailable']
                    );
                } else if (errorsList === 'registration.errorDuplicatePhone' || errorsList === 'error.duplicatePhone' || _this.props.errorsList === 'registration.errorDuplicateEmail' || _this.props.errorsList === 'errorDuplicateEmail') {
                    return _react3.default.createElement(
                        _reactBootstrap.Alert,
                        { bsStyle: 'danger', className: 'inner-right-xs' },
                        _this.renderErrorList(errorsList),
                        _react3.default.createElement(
                            'a',
                            { className: 'rec_pass', onClick: _this.onClickPassRecovery },
                            lang['store.registration_form.restore_password']
                        )
                    );
                } else {
                    return _react3.default.createElement(
                        _reactBootstrap.Alert,
                        { bsStyle: 'danger', className: 'inner-right-xs' },
                        _this.renderErrorList(errorsList)
                    );
                }
            }

            return '';
        }, _this.onClickPassRecovery = function (event) {
            event.preventDefault();
            if (_this.props.onClickPassRecovery) {
                _this.props.onClickPassRecovery(event);
            }
        }, _this.handlePhoneChange = function (phone, country) {
            _this.props.changeField('phone')(null, phone);
        }, _this.renderField = function () {
            var _this$props2 = _this.props,
                changeField = _this$props2.changeField,
                lang = _this$props2.lang,
                setting = _this$props2.setting;


            var result = [];

            if (setting.additionalFieldSettings) {
                var additionalFieldSettings = setting.additionalFieldSettings;


                result = additionalFieldSettings.map(function (item, i) {
                    var typeAdditionalField = item.typeAdditionalField,
                        show_in_registration = item.show_in_registration,
                        required_in_registration = item.required_in_registration;

                    var formInput = null;

                    if (show_in_registration) {
                        if (typeAdditionalField && typeAdditionalField.slug === 'phone') {
                            formInput = _react3.default.createElement(_components2.PhoneEmailInput, {
                                value: _this.props.phone,
                                defaultCountry: '',
                                flagsImagePath: '/assets/images/flags.png',
                                placeholder: lang['register.placeholderPhone'],
                                onChange: _this.handlePhoneChange
                            });
                        } else {
                            formInput = _react3.default.createElement(_reactBootstrap.FormControl, {
                                name: typeAdditionalField.slug,
                                onChange: changeField(typeAdditionalField.slug),
                                placeholder: lang[typeAdditionalField.placeholder_lang_data] || lang[typeAdditionalField.lang_data],
                                type: 'text',
                                value: _this.props[typeAdditionalField.slug]
                            });
                        }

                        return _react3.default.createElement(
                            _reactBootstrap.FormGroup,
                            {
                                controlId: typeAdditionalField.slug,
                                key: typeAdditionalField.slug + '-' + i
                            },
                            _react3.default.createElement(
                                _reactBootstrap.ControlLabel,
                                null,
                                '' + (lang[typeAdditionalField.lang_data] || typeAdditionalField.description) + (required_in_registration ? '*' : ' ')
                            ),
                            formInput
                        );
                    }
                });
            }

            return result;
        }, _this.showCaptcha = function () {
            if (_this.props.showCaptcha) {
                return _react3.default.createElement(
                    _reactBootstrap.FormGroup,
                    null,
                    _this.props.showCaptcha()
                );
            }

            return '';
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(RegistrationFormView, [{
        key: 'renderErrorList',
        value: function renderErrorList(list) {
            var _this2 = this;

            if (Array.isArray(list)) {
                return list.map(function (text, i) {
                    return _react3.default.createElement(
                        'p',
                        { key: i },
                        _this2.props.lang[text]
                    );
                });
            } else if (typeof list === 'string') {
                return this.props.lang[list];
            } else {
                return null;
            }
        }

        /**
         * Рендер включенных полей для регистрации
         */

    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                changeField = _props.changeField,
                linkField = _props.linkField,
                onSubmit = _props.onSubmit,
                setting = _props.setting,
                lang = _props.lang,
                preload = _props.preload;


            return _react3.default.createElement(
                _components2.Preloader,
                { preload: preload },
                this.showError(),
                _react3.default.createElement(
                    'section',
                    { id: 'registration-form', className: 'registration_page' },
                    _react3.default.createElement(
                        'div',
                        { className: 'bordered' },
                        _react3.default.createElement(
                            _reactBootstrap.Form,
                            { onSubmit: onSubmit },
                            this.renderField(),
                            _react3.default.createElement(
                                _reactBootstrap.FormGroup,
                                { controlId: 'password' },
                                _react3.default.createElement(
                                    _reactBootstrap.ControlLabel,
                                    null,
                                    lang['login.password'],
                                    '*'
                                ),
                                _react3.default.createElement(_reactBootstrap.FormControl, {
                                    type: 'password',
                                    name: 'PASSWORD',
                                    value: this.props.password,
                                    onChange: changeField('password'),
                                    placeholder: lang['register.placeholderPassword']
                                })
                            ),
                            this.showCaptcha(),
                            _react3.default.createElement(
                                _reactBootstrap.FormGroup,
                                null,
                                _react3.default.createElement(
                                    _reactBootstrap.Button,
                                    {
                                        type: 'submit',
                                        bsStyle: 'primary',
                                        className: 'form-control g-recaptcha',
                                        disabled: this.props.disabledSubmit
                                    },
                                    lang['store.common.sign_up']
                                )
                            ),
                            _react3.default.createElement(
                                _reactBootstrap.FormGroup,
                                null,
                                _react3.default.createElement(
                                    'div',
                                    { className: 'text-center to-page-registration' },
                                    _react3.default.createElement(
                                        _reactRouter.Link,
                                        { className: 'login_link', to: '#', onClick: this.onClickAuth },
                                        lang['login.logIn']
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return RegistrationFormView;
}(_react2.Component), _class.propTypes = {
    changeField: _react2.PropTypes.func.isRequired,
    errorsList: _react2.PropTypes.oneOfType([_react2.PropTypes.string, _react2.PropTypes.array]),
    lang: _react2.PropTypes.object,
    onClickAuth: _react2.PropTypes.func,
    onSubmit: _react2.PropTypes.func.isRequired,
    password: _react2.PropTypes.string.isRequired,
    preload: _react2.PropTypes.bool,
    setting: _react2.PropTypes.object.isRequired

}, _temp2));

exports.default = RegistrationFormView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/RegistrationForm/default/RegistrationFormView.jsx
// module id = 1750
// module chunks = 0